// extracted by mini-css-extract-plugin
module.exports = {"form-b-wizard-back":"style_form-b-wizard-back__MSWjY"};